import { REQUEST } from '../../webservice/redux' 

import notification from './notification'
import modal from './modal'
import loading from './loading'

import rule from './rule'

import { all } from 'redux-saga/effects'

import buildWebserviceSaga from 'iotera-webservice-redux-saga/sagas/webservice'

const webservice =  buildWebserviceSaga(REQUEST);

export default function* rootSaga() {
    yield all([
        ...webservice, 
        ...notification,
        ...modal,
        ...loading,
        ...rule
    ]);
}
